import classNames     from 'classnames';
import React, { FC }  from 'react';
import { Size }       from '../../../types';
import { ClassValue } from 'classnames/types';

interface TextLinkProps {
	as?: any,
	size?: Size,
	className?: ClassValue,
	
	[ additionalProps: string ]: any
}

const defaultProps: TextLinkProps = {
	as:        'a',
	size:      null,
	className: null,
}

const TextLink: FC<TextLinkProps> = ( _props ) => {
	
	let { as: Tag, size, ...props } = _props;
	let classes                     = classNames(
		{
			'cursor--pointer':     true,
			'opacity-hover--80':   true,
			[ `text--${ size }` ]: size,
		},
		props.className
	);
	
	return (
		<Tag { ...props } className={ classes }/>
	);
};

TextLink.defaultProps = defaultProps;

export { TextLink }
